import style from "./BlogArticleImage.module.css";

export enum FloatType {
    LEFT = "floatLeft", 
    RIGHT = "floatRight"

}

export type Props = {
    img: string;
    subtitle?: string;
    isVertical: boolean;
    float?: FloatType;
}

function BlogArticleImage(props: Props): JSX.Element {

    function getImageClass(): string {
        const base = style.image + " ";
        let className = "";

        if (props.isVertical) {
            className = base + style.vertical;
        }
        else {
            className = base + style.horizontal;
        }

        if (props.float !== undefined) {
            className += " " + style[props.float]
        }

        return className
    }

    return (
        <>
        <div className="text-center">
            <img src={props.img} alt="article content" className={getImageClass()}/>
            {props.subtitle !== undefined ? <p className={style.subtitle}>{props.subtitle}</p> : ""}
        </div>
        </>
    );
}

export default BlogArticleImage;